import "./InventoryScreenComponent.scss";
import SearchComponent from "../../shared/components/search/SearchComponent";
import {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import commonService from "../../shared/services/common.service";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {CommonService} from "../../shared/services";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";
import {Link} from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import InventoryListTableComponent from "./inventory-list-table/InventoryListTableComponent";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import InventoryFiltersComponent from "./inventory-filters/InventoryFiltersComponent";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";

interface InventoryScreenComponentProps {

}
const FiltersInitialState: any = {
    search: '',
    facilityTypes: [],
    facilityTypesObjs: [],
    createdByObjs: [],
    createdByIds: [],
    statuses: [],
    statusesObjs: [],
    cities: [],
    citiesObjs: [],
    startDate: '',
    endDate: ''
}

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['statusesObjs', 'createdByObjs', 'facilityTypesObjs', 'citiesObjs'];

const InventoryScreenComponent = (props: InventoryScreenComponentProps) => {
    const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    // const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const {
        userList,
    } = useSelector((state: IRootReducerState) => state.staticData);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentNavParams("Inventory", "Inventory"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    const applyFilters = useCallback((filterData: any) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            ...filterData
        }));
        setShowFiltersDrawer(false);
    }, []);

    useEffect(() => {
        CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
    }, [filterData]);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
                startDate: queryParamData.startDate || '',
                endDate: queryParamData.endDate || '',
            };
            if (queryParamData?.testPanelIds?.length) {
                data['testPanelIds'] = queryParamData.testPanelIds.split(',') || [];
            }
            data['testPanelObjs'] = userList.filter((item: any) => data['testPanelIds']?.includes(item?.id?.toString()));

            if (queryParamData?.createdByIds?.length) {
                data['createdByIds'] = queryParamData.createdByIds.split(',') || [];
            }
            data['createdByObjs'] = userList.filter((item: any) => data['createdByIds']?.includes(item?.id?.toString()));

            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData, userList]);


    const clearAllFilters = useCallback(() => {
        setFilterData(_.cloneDeep(FiltersInitialState));
    }, []);

    return (
        <div className="inventory-list-screen screen">
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search Product"}
                                id="search_input"
                                placeholder={""}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>

                        <div className="page-extra-options">
                            {
                                commonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                <ButtonComponent
                                    type="button"
                                    id="clear_all_filters"
                                    className={"clear-all-filters"}
                                    color={"secondary"}
                                    variant={"text"}
                                    fullWidth={false}
                                    handleClick={clearAllFilters}
                                >
                                    Clear All
                                </ButtonComponent>
                            }
                            <ButtonComponent
                                type="button"
                                id="csv_btn"
                                color={"primary"}
                                variant={"outlined"}
                                fullWidth={false}
                                handleClick={() => setShowFiltersDrawer(true)}
                                startIcon={<FilterAltIcon/>}>
                                Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                            </ButtonComponent>
                            {/*{*/}
                            {/*    commonService.checkAccess('Facility',*/}
                            {/*        "inventoryCsvDownload", currentUser?.userAccessModules) &&*/}
                            {/*    <ButtonComponent*/}
                            {/*        type="button"*/}
                            {/*        id="csv_btn"*/}
                            {/*        color={"secondary"}*/}
                            {/*        variant={"contained"}*/}
                            {/*        fullWidth={false}*/}
                            {/*        isLoading={isCSVDownloading}*/}
                            {/*        handleClick={downloadCSV}*/}
                            {/*        disabled={isCSVDownloading}*/}
                            {/*        startIcon={<Download/>}*/}
                            {/*    >*/}
                            {/*        CSV*/}
                            {/*    </ButtonComponent>*/}
                            {/*}*/}
                            {/*{*/}
                            {/*    commonService.checkAccess('Facility',*/}
                            {/*        'inventoryAdd', currentUser?.userAccessModules) &&*/}

                                <Link to={CommonService._routeConfig.InventoryAddRoute()}>
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        id="add_inventory_button"
                                        startIcon={<AddIcon/>}
                                    >
                                        New Product
                                    </ButtonComponent>
                                </Link>
                            {/*}*/}
                        </div>
                    </div>
                    <div className="page-data-wrapper">
                        <InventoryListTableComponent filterData={filterData}/>
                    </div>
                </div>
            </div>
            <DrawerComponent open={showFilterDrawer}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             onClose={() => setShowFiltersDrawer(false)}
            >
                <InventoryFiltersComponent filtersData={filterData} onFiltersApply={applyFilters} />
            </DrawerComponent>
        </div>
    );

};

export default InventoryScreenComponent;
